import { render, staticRenderFns } from "./Vaccination.vue?vue&type=template&id=30faad68&"
import script from "./Vaccination.vue?vue&type=script&lang=js&"
export * from "./Vaccination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports